import {postRequest} from "./helper"
export const allgetCountApi = (data) => postRequest('admin/dashboard',data);





// WEBPACK FOOTER //
// ./src/api/Admin/Home.js